import {
  extensionViewOf,
  formatReference,
  formatText,
  productExtensionStateOf,
  type ExtensionSpec,
  type ExtensionView,
  type ProductExtensionEnvelope,
  type ProductExtensionState,
} from '@krp/client-runtime'

import { ONEC_EXTENSION_KIND, onecProductExtension } from '../api/productExtensionApi'

/** Пустая ссылка 1С — нулевой GUID: «группы нет» (CLAUDE.md §3). */
const EMPTY_REFERENCE = '00000000-0000-0000-0000-000000000000'

/**
 * Что показываем из расширения карточки 1С по версиям схемы. Состав `payload` v1 — решение службы 1С (RP-FB71, 3.2): код,
 * группа, полное наименование, единица, оригинал вида ставки. Поля, которых служба не прочитала, просто не показываются.
 */
export const ONEC_EXTENSION_SPEC: ExtensionSpec = {
  versions: {
    1: [
      { id: 'code', label: 'Код', inSummary: true, format: formatText },
      { id: 'printName', label: 'Полное наименование', inSummary: true, format: formatText },
      { id: 'parentKey', label: 'Группа', inSummary: true, format: formatReference('в группе', 'вне групп', [EMPTY_REFERENCE]) },
      { id: 'unitName', label: 'Единица', inSummary: false, format: formatText },
      { id: 'unitCode', label: 'Код единицы', inSummary: false, format: formatText },
      { id: 'vatKind', label: 'Вид ставки НДС в 1С', inSummary: false, format: formatText },
    ],
  },
}

/** Вид расширения карточки 1С: чистая функция, без запроса. */
export const onecExtensionViewOf = (envelope: ProductExtensionEnvelope): ExtensionView => extensionViewOf(envelope, ONEC_EXTENSION_SPEC)

/** Читает расширение карточки 1С у службы 1С и отдаёт готовый вид. */
export function useOneCProductExtension(resourceId: string, remoteKey: string): ProductExtensionState {
  const result = onecProductExtension.useQuery({ resourceId, refKey: remoteKey })
  return productExtensionStateOf(result, ONEC_EXTENSION_SPEC)
}

/** Описание вида «1С» для реестра источников товара (composition): только то, что знает пакет вида. */
export const onecProductExtensionSource = {
  kind: ONEC_EXTENSION_KIND,
  useExtension: useOneCProductExtension,
} as const
